import React from 'react'
import renderHTML from 'react-render-html'
import './styles.scss'
import { Scrollchor } from 'react-scrollchor'

export default class TextExpander extends React.Component<Props> {
  constructor(props) {
    super(props)
    this.state = {
      isExpanded: false,
    }
    this.toggleMore = this.toggleMore.bind(this)
  }

  toggleMore(e) {
    e.preventDefault()
    if (this.state.isExpanded) {
      this.setState({
        isExpanded: false,
        fade: false
      })
    } else {
      // GA tracking
      const clickedPerson = e.currentTarget.getAttribute('data-person')
      console.log('person:' + clickedPerson)
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'Interactions',
        event_action: 'click',
        event_label: 'Protokoll: ' + clickedPerson
      })
      this.setState({
        isExpanded: true,
        fade: true
      })
    }
  }

  render() {
    return (
      <div className='chart-wrapper'>
        <div
          className={
            this.state.isExpanded
              ? 'chart-info expanded'
              : 'chart-info collapsed'
          }
        >
          <div className={this.state.fade ? 'notDisplay' : 'fade'} id='mehrLesen'>{renderHTML(this.props.shortText)}</div>
          <div className='show-more'>
            <a onClick={this.toggleMore} data-person={this.props.trackingID}>
              weiterlesen
              <i className='chevron down icon small' />
            </a>
          </div>
          <div className='additional-text'>
            {renderHTML(this.props.longText)}
          </div>
          <Scrollchor to='#mehrLesen' animate={{ duration: 200, offset: 50 }}>
          <div className='show-less'>
            <a onClick={this.toggleMore} href='#mehrLesen'>
              weniger <i className='chevron up icon small' />
            </a>
          </div>
          </Scrollchor>
        </div>
      </div>
    )
  }
}
